import React from 'react';
import Head from 'next/head';
import Favicon from '@/dataroom/ui/components/Landing/researchRoom/components/Favicon';
import Section from '@/Framework/UI/Pages/Landing/Sections/Section';
import ReadyToStart from '../../components/ReadyToStart';
import Intro from './Intro';
import Overview from './Overview';
import Details from '../Home/Details';

const Regulations = () => (
  <>
    <Favicon />
    <Head>
      <title>Secure Virtual Data Room | ResearchRoom</title>
      <meta
        name="description"
        content="A brief handbook summarizing regulations and guidance for syndicate and research desks in EMEA and APAC."
      />
    </Head>
    <Intro />
    <Overview />
    <Details />
    <Section padding="top" />
    <ReadyToStart />
  </>
);

export default Regulations;
